import AppModal from '@/components/AppModal/AppModal';
import BoldSmallText from '@/components/BoldSmallText';
import RegularText from '@/components/RegularText';
import { PricingPlan } from '@/constants/enum';
import { Banner, BlockStack, Box, Checkbox } from '@shopify/polaris';
import { Dispatch, SetStateAction, useMemo } from 'react';

interface IProps {
  locationList?: {
    value: number;
    label: string;
  }[];
  locationIds: number[];
  setLocationIds: Dispatch<SetStateAction<number[]>>;
  open: boolean;
  setIsOpenDownrageModal: Dispatch<SetStateAction<boolean>>;
  setIsOpenLocationModal: Dispatch<SetStateAction<boolean>>;
  chosenPlan: PricingPlan;
}

export const ChooseLocationModal = ({
  locationList,
  locationIds,
  setLocationIds,
  open,
  setIsOpenDownrageModal,
  setIsOpenLocationModal,
  chosenPlan,
}: IProps) => {
  const locationTitle = useMemo(() => {
    switch (chosenPlan) {
      case PricingPlan.Free:
        return 'Please select one location to keep in your Free Plan';
      case PricingPlan.Essential:
        return 'Please select 2 locations to keep in your Essential Plan';
      case PricingPlan.Smart:
        return 'Please select 5 locations to keep in your Smart Plan';
    }
  }, [chosenPlan]);

  const getLocationQuota = (plan: string) => {
    switch (plan) {
      case PricingPlan.Free:
        return 1;
      case PricingPlan.Essential:
        return 2;
      case PricingPlan.Smart:
        return 5;
      default:
        return 20;
    }
  };

  return (
    <AppModal
      title="Choose location to keep"
      open={open}
      onCancel={() => {
        setLocationIds([]);
        setIsOpenLocationModal(false);
        setIsOpenDownrageModal(true);
      }}
      size="small"
      onSubmit={() => {
        setIsOpenLocationModal(false);
        setIsOpenDownrageModal(true);
      }}
      submitText="Cancel"
      cancelText="Confirm selection"
      swapActions
    >
      <RegularText>{locationTitle}</RegularText>
      <BlockStack gap={'100'}>
        {locationList?.map((item) => (
          <Checkbox
            key={item?.value}
            label={item.label}
            checked={locationIds.includes(item.value)}
            onChange={(isChecked) => {
              if (!setLocationIds) return;
              setLocationIds((prev) => {
                if (isChecked) {
                  return [...prev, item.value];
                } else {
                  return prev.filter((id) => id !== item.value);
                }
              });
            }}
            disabled={locationIds.length === getLocationQuota(chosenPlan) && !locationIds.includes(item.value)}
          />
        ))}
      </BlockStack>
      <Box paddingBlockStart={'200'}>
        <Banner tone="critical">
          <BoldSmallText as="span">Important:</BoldSmallText> All other locations will be removed, and data cannot be recovered.
        </Banner>
      </Box>
    </AppModal>
  );
};
